import React, { useState, useEffect } from "react";
import { Icones, WrapperIcone } from "./styleHome";
import { Coffee, MapPin, Terminal, Users } from "react-feather";

const IconesComponents = ({ icone, numero, texto }) => {
  return (
    <WrapperIcone>
      {icone}
      <div>{numero}</div>
      <span>{texto}</span>
    </WrapperIcone>
  );
};

export const IconeHome = () => {
  const [estados, setEstados] = useState(0);
  const [cafe, setCafe] = useState(8000);
  const [codigo, setCodigo] = useState(7774);
  const [clientes, setClientes] = useState(0);

  useEffect(() => {
    let interval = null;
    interval = setInterval(() => {
      setEstados(estados => estados + 1);
    }, 100);
    if (estados > 24) {
      clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, [estados]);

  useEffect(() => {
    let interval = null;
    interval = setInterval(() => {
      setCafe(cafe => cafe + 5);
      setCodigo(codigo => codigo + 350);
      setClientes(clientes => clientes + 15);
    }, 0.03);
    if (cafe > 9045) {
      clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, [cafe, codigo, clientes]);

  return (
    <Icones>
      <div>
        <IconesComponents
          icone={<MapPin />}
          numero={estados + "+"}
          texto={"ESTADOS DO BRASIL"}
        />
        <IconesComponents
          icone={<Coffee />}
          numero={cafe + "+"}
          texto={"XÍCARAS DE CAFÉ"}
        />
        <IconesComponents
          icone={<Terminal />}
          numero={codigo + "+"}
          texto={"LINHAS DE CÓDIGO"}
        />
        <IconesComponents
          icone={<Users />}
          numero={clientes + "+"}
          texto={"CLIENTES SATISFEITOS"}
        />
      </div>
    </Icones>
  );
};
